(function($) {
    $(() => {
        var scrollPos = 0;

        $('.navbar-toggler').on('click', function() {
            $(this).toggleClass('is-active');
            $('.navbar-collapse').toggleClass('is-opened');
           
            // Fix body if navbar is opened on mobile
            // 
            // 
            if($('.navbar-collapse').hasClass('is-opened')) {
                scrollPos = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    position: 'fixed',
                    width: '100vw',
                    top : -scrollPos
                });
            } else {
                $('body').css({
                    overflow: '',
                    position: 'relative',
                    top: ''
                });
                $(window).scrollTop(scrollPos);
            }
            
        });

    });
})(jQuery);
